import DiarysList from "./DiarysList";
import Diary from "./Diary";
import DiaryHeader from "./DiaryHeader";
import { useState, useEffect, useRef, useContext } from "react";
import AddDiary from "./Dialogs/AddDiary";
import AddPost from "./Dialogs/AddPost";
import EditPost from "./Dialogs/EditPost";
import BackButton from "../CommonComponents/BackButton/BackButton";
import { getDailyList, getDailyPosts } from "./CommonFunc";
import ThemeControl from "../CommonComponents/ThemeControl/ThemeControl";
import InfiniteScroll from "react-infinite-scroll-component";
import { useWebSocket, wsCreater } from "../useWebSocket";
import { AppContext } from "../Context/AppContext";
import DiaryToolbox from "./DiaryToolbox";
import EditTab from "./Dialogs/EditTab";
import { useQuery } from "../Site/effects";
import PencilIcon from "../Icons/Pencil";
import EyeIcon from "../Icons/Eye";

window.addDiaryFlag = false;

function DiaryLayout(props) {
	const [diarys, setDiarys] = useState([]);
	const [currentDiary, setCurrentDiary] = useState({});
	const [currentDiaryPosts, setCurrentDiaryPosts] = useState([]);
	const [selectedPost, setSelectedPost] = useState(null);
	const [openAddDiary, setOpenAddDiary] = useState(false);
	const [openAddPost, setOpenAddPost] = useState(false);
	const [openEditPost, setOpenEditPost] = useState(false);
	const [openEditTab, setOpenEditTab] = useState(false);
	const [isEnd, setIsEnd] = useState(false);
	const [isAdmin, setIsAdmin] = useState(false);
	const { theme } = useContext(AppContext);
	const contentColumnRef = useRef();
	const contentRef = useRef();
	const query = useQuery();
	const navigationRef = useRef();
	const supportRef = useRef();

	useWebSocket();

	const refreshMenuList = (setFirstTab = true) => {
		getDailyList(query.get("isNew") ?? 1).then((res) => {
			if (Array.isArray(res)) {
				setDiarys(res);
				if (setFirstTab) {
					setCurrentDiary(res[0]);
				}
				if (res.length === 0) {
					setIsEnd(true);
				}
			} else {
				setIsEnd(true);
			}
		});
	};

	const handleDiaryOpener = (event) => {
		// navigationRef.current.style.width = "400px";
		if (navigationRef.current.style.flex === "0 0 200px") {
			navigationRef.current.style.flex = "0 0 0px";
		} else {
			navigationRef.current.style.flex = "0 0 200px";
		}
	};

	const handleDiaryEdit = (event) => {
		if (supportRef.current.style.flex === "0 0 200px") {
			supportRef.current.style.flex = "0 0 0px";
		} else {
			supportRef.current.style.flex = "0 0 200px";
		}
	};

	useEffect(() => {
		refreshMenuList();
	}, []);

	useEffect(() => {
		if (currentDiary?.ID === undefined) {
			return;
		}
		setIsEnd(false);
		getDailyPosts(currentDiary.ID, 0, 10).then((posts) => {
			if (posts.length < 10) {
				setIsEnd(true);
			}
			setCurrentDiaryPosts(posts);
		});
		setSelectedPost(null);
		contentColumnRef.current.scrollTo({ top: 0 });
	}, [currentDiary]);

	return (
		<>
			<div className='main-container' color={theme.color}>
				<div
					className='head'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.headerFontMultiplier
						}px`,
					}}
				>
					<div className='navigation-header'>
						<BackButton />
					</div>
					<div className='content-header'>
						<DiaryHeader currentDiary={currentDiary} />
					</div>
					<div className='support-header'>
						<ThemeControl />
						<PencilIcon
							width={2}
							height={2}
							func={() => setIsAdmin(true)}
							className={`admin-toggle ${isAdmin ? "admin-toggle-active" : ""}`}
						/>
						<EyeIcon
							width={3}
							height={3}
							func={() => setIsAdmin(false)}
							className={`eye-toggle ${!isAdmin ? "eye-toggle-active" : ""}`}
						/>
					</div>
				</div>
				<div className='body'>
					<div
						ref={navigationRef}
						className='navigation-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
							}px`,
						}}
					>
						<div className='navigation'>
							<DiarysList
								currentDiary={currentDiary}
								setCurrentDiary={setCurrentDiary}
								diarys={diarys}
								setOpenAddDiary={setOpenAddDiary}
								setDiarys={setDiarys}
								setOpenAddPost={setOpenAddPost}
							/>
						</div>
					</div>
					<div
						ref={contentColumnRef}
						id='scrollableContentColumn'
						className='content-column'
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
							}px`,
						}}
					>
						<InfiniteScroll
							scrollableTarget='scrollableContentColumn'
							dataLength={currentDiaryPosts.length}
							next={() => {
								getDailyPosts(
									currentDiary.ID,
									currentDiaryPosts.length,
									10
								).then((posts) => {
									if (posts.length === 0) {
										setIsEnd(true);
									} else {
										setIsEnd(false);
									}
									setCurrentDiaryPosts((prev) => [...prev, ...posts]);
								});
							}}
							hasMore={!isEnd}
							loader={
								<div className='loader'>
									<div className='spinner'></div>
									<p>Загрузка...</p>
								</div>
							}
							endMessage={
								<>
									<div className='all-data-loaded'>Загружены все данные</div>
								</>
							}
						>
							<div ref={contentRef} id='content' className='content'>
								<Diary
									currentDiary={currentDiary}
									selectedPost={selectedPost}
									setSelectedPost={setSelectedPost}
									currentDiaryPosts={currentDiaryPosts}
									setCurrentDiaryPosts={setCurrentDiaryPosts}
									setOpenEditPost={setOpenEditPost}
									contentRef={contentRef}
								/>
							</div>
						</InfiniteScroll>
					</div>
					<div
						className='support-column'
						ref={supportRef}
						style={{
							fontSize: `${
								(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
							}px`,
						}}
					>
						<div className='support'>
							<DiaryToolbox
								currentDiary={currentDiary}
								selectedPost={selectedPost}
								setSelectedPost={setSelectedPost}
								currentDiaryPosts={currentDiaryPosts}
								setCurrentDiaryPosts={setCurrentDiaryPosts}
								setOpenEditPost={setOpenEditPost}
								setOpenAddPost={setOpenAddPost}
								setOpenAddDiary={setOpenAddDiary}
								refreshMenuList={refreshMenuList}
								setOpenEditTab={setOpenEditTab}
								isAdmin={isAdmin}
							/>
						</div>
					</div>
				</div>
				<div className='footer'>
					<div className='navigation-footer'>
						<div className='button-action action' onClick={handleDiaryOpener}>
							{"Дневники"}
						</div>
					</div>
					<div className='content-footer'></div>
					<div className='support-footer'>
						<div className='button-action' onClick={handleDiaryEdit}>
							{"Редактирование"}
						</div>
					</div>
				</div>
			</div>
			{openAddDiary ? (
				<AddDiary
					setOpenAddDiary={setOpenAddDiary}
					setDiarys={setDiarys}
					setCurrentDiary={setCurrentDiary}
					theme={theme}
				/>
			) : null}
			{openEditTab ? (
				<EditTab
					setOpenEditTab={setOpenEditTab}
					refreshMenuList={refreshMenuList}
					theme={theme}
					currentDiary={currentDiary}
				/>
			) : null}
			{openAddPost ? (
				<AddPost
					setOpenAddPost={setOpenAddPost}
					setDiarys={setDiarys}
					diarys={diarys}
					currentDiary={currentDiary}
					setSelectedPost={setSelectedPost}
					setCurrentDiaryPosts={setCurrentDiaryPosts}
					theme={theme}
				/>
			) : null}
			{openEditPost ? (
				<EditPost
					setOpenEditPost={setOpenEditPost}
					setDiarys={setDiarys}
					diarys={diarys}
					currentDiary={currentDiary}
					setSelectedPost={setSelectedPost}
					selectedPost={selectedPost}
					currentDiaryPosts={currentDiaryPosts}
					setCurrentDiaryPosts={setCurrentDiaryPosts}
					setOpenAddPost={setOpenAddPost}
					theme={theme}
				/>
			) : null}
		</>
	);
}

export default DiaryLayout;
